// extracted by mini-css-extract-plugin
export default {"Nav":"Navbar_Nav__ewpVu","Map":"Navbar_Map__K7zv4","mainlogo":"Navbar_mainlogo__4aYkH"};